import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import { useCallback, useState } from 'react';
import DebuggerPanelSourceSelectBody from 'automation-ui-canvas/components/panels/debugger-panel/DebuggerPanelSourceSelectBody';
import DebuggerPanelStepBody from 'automation-ui-canvas/components/panels/debugger-panel/DebuggerPanelStepBody';
import { routeToSpecificAction } from 'automation-ui-canvas/utils/routingUtils';
import { useHistory } from 'react-router-dom';
import { getEnrollmentConfigRoute } from 'automation-ui-canvas/utils/absoluteRoutingUtils';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIButton from 'UIComponents/button/UIButton';
import { useGetIsUngated } from 'automation-ui-core/hooks/authHooks';
import { getActionHeaderTitle } from 'automation-ui-action-features/records/recordsUtils';
import { ENROLLMENT } from 'automation-ui-flow-core/canvas/SpecialActionIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const routeToActionConfig = (history, actionId, flow) => {
  const action = actionId ? flow.actions.get(actionId) : null;
  const configId = action ? action.getActionType() : null;
  if (actionId === ENROLLMENT) {
    return history.replace({
      pathname: getEnrollmentConfigRoute({
        flow
      }),
      state: {
        scrollToAction: {
          actionId,
          scrollBehavior: 'smooth'
        }
      },
      search: history.location.search
    });
  }
  const flowId = flow.getFlowId();
  return routeToSpecificAction({
    history,
    actionId,
    configId,
    flowId,
    extraParams: {
      'panel-open': 'debugger'
    }
  });
};
export const DebuggerPanel = ({
  flow,
  onClose
}) => {
  const isUngated = useGetIsUngated();
  const history = useHistory();
  const [objectId, setObjectId] = useState();
  const [actionExecutionData] = useState();
  const [currentExecutionTime, setCurrentExecutionTime] = useState(new Date().getTime());
  const [currentActionId, setCurrentActionId] = useState(null);
  const [currentPageId, setCurrentPageId] = useState('HOME');
  const [previousActionIdBreadcrumbs, setPreviousActionIdBreadcrumbs] = useState([]);
  const width = currentPageId === 'HOME' ? 500 : 700;
  const getTitle = getActionHeaderTitle({
    flowActions: flow.actions,
    firstActionId: flow.firstActionId,
    isUngated
  });
  const handleNextStep = useCallback(() => {
    if (currentPageId === 'FINISH_STEPPER') {
      onClose();
    }
    let nextActionId = actionExecutionData === null || actionExecutionData === void 0 ? void 0 : actionExecutionData.nextActionId;
    setCurrentExecutionTime(currentExecutionTime + 1000 * 60); // TODO: use BE timestamps

    setPreviousActionIdBreadcrumbs(currentActionId ? previousActionIdBreadcrumbs.concat(currentActionId) : previousActionIdBreadcrumbs);
    if (currentPageId === 'HOME') {
      routeToActionConfig(history, ENROLLMENT, flow);
      setCurrentActionId(ENROLLMENT);
      setCurrentPageId('STEP_EXECUTION');
      return;
    } else if (actionExecutionData && !nextActionId) {
      setCurrentActionId(null);
      setCurrentPageId('FINISH_STEPPER');
      routeToActionConfig(history, undefined, flow);
      return;
    } else if (!actionExecutionData) {
      nextActionId = flow.firstActionId;
    }
    setCurrentActionId(nextActionId);
    routeToActionConfig(history, nextActionId, flow);
    setCurrentPageId('STEP_EXECUTION');
    return;
  }, [history, flow, currentPageId, previousActionIdBreadcrumbs, onClose, currentExecutionTime, actionExecutionData, currentActionId]);
  const handlePreviousStep = useCallback(() => {
    setCurrentExecutionTime(currentExecutionTime - 1000 * 60); // TODO: use BE timestamps
    const activePagePreviousActionIdBreadcrumbs = [...previousActionIdBreadcrumbs];
    const previousActionId = activePagePreviousActionIdBreadcrumbs.pop();
    setPreviousActionIdBreadcrumbs(activePagePreviousActionIdBreadcrumbs);
    if (!previousActionId) {
      setCurrentActionId(null);
      setCurrentPageId('HOME');
      return;
    }
    setCurrentActionId(previousActionId);
    setCurrentPageId('STEP_EXECUTION');
    routeToActionConfig(history, previousActionId, flow);
    return;
  }, [history, flow, currentExecutionTime, previousActionIdBreadcrumbs]);
  const getStepName = () => {
    if (currentPageId === 'HOME') {
      return null;
    } else if (currentPageId === 'FINISH_STEPPER') {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "debuggerPanel.nextButtons.previous"
      });
    } else if (currentActionId === ENROLLMENT) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "debuggerPanel.stepNames.enrollment"
      });
    } else {
      return getTitle({
        actionId: currentActionId
      });
    }
  };
  const stepName = getStepName();
  const getPreviousStepButtonLabel = () => {
    if (currentPageId === 'HOME') {
      return null;
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "debuggerPanel.nextButtons.previous"
    });
  };
  const previousStepButtonLabel = getPreviousStepButtonLabel();
  const getNextStepButtonLabel = () => {
    if (currentPageId === 'HOME') {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "debuggerPanel.nextButtons.startStepping"
      });
    } else if (currentPageId === 'FINISH_STEPPER') {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "debuggerPanel.nextButtons.end"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "debuggerPanel.nextButtons.next"
    });
  };
  const nextStepButtonLabel = getNextStepButtonLabel();
  return /*#__PURE__*/_jsxs(UIPanel, {
    "data-test-id": "debugger-panel",
    width: width,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: stepName ? /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "debuggerPanel.headerWithName",
          options: {
            stepName
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "debuggerPanel.headerNoName"
        })
      })
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsxs(PanelSection, {
        blockSize: "100%",
        padding: "0",
        margin: "0",
        children: [currentPageId === 'HOME' && /*#__PURE__*/_jsx(DebuggerPanelSourceSelectBody, {
          flowObjectTypeId: flow.getObjectTypeId(),
          onObjectIdSelected: setObjectId,
          objectId: objectId
        }), currentPageId === 'STEP_EXECUTION' && /*#__PURE__*/_jsx(DebuggerPanelStepBody, {
          flow: flow,
          objectId: objectId,
          actionId: currentActionId
        }), currentPageId === 'FINISH_STEPPER' && /*#__PURE__*/_jsx("span", {
          children: "The end"
        })]
      })
    }), /*#__PURE__*/_jsxs(UIPanelFooter, {
      className: "p-y-4 p-x-4",
      children: [previousStepButtonLabel && /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary",
        onClick: handlePreviousStep,
        children: previousStepButtonLabel
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary",
        onClick: handleNextStep,
        children: nextStepButtonLabel
      })]
    })]
  });
};
export default DebuggerPanel;